import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Clock, Eye } from "lucide-react";
import { STATUS } from "@/components/AppointmentTable";

const MODIFIER_CLASSES = { hasAppt: "relative font-semibold text-teal-700 after:content-[''] after:absolute after:bottom-1 after:left-1/2 after:-translate-x-1/2 after:h-1 after:w-1 after:rounded-full after:bg-teal-600" };

export default function DayCalendar({ selectedDate, onSelectDate, apptDays, dayAppointments, onViewReceipt }) {
  const modifiers = { hasAppt: apptDays };
  return (
    <div className="grid lg:grid-cols-[auto_1fr] gap-6 items-start">
      <div className="bg-white rounded-2xl border border-slate-200 p-3 w-fit">
        <Calendar mode="single" selected={selectedDate} onSelect={(d) => d && onSelectDate(d)}
          modifiers={modifiers} modifiersClassNames={MODIFIER_CLASSES} data-testid="appointments-calendar" />
        <div className="flex items-center gap-2 px-3 pb-2 pt-1 text-xs text-slate-500">
          <span className="h-1.5 w-1.5 rounded-full bg-teal-600 inline-block" /> Has appointments
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 p-5 min-h-[320px]">
        <div className="flex items-center justify-between mb-4 flex-wrap gap-2">
          <h2 className="font-head text-lg font-semibold">
            {selectedDate.toLocaleDateString("en-IN", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}
          </h2>
          <Badge variant="outline" className="bg-teal-50 text-teal-700 border-teal-200">
            {dayAppointments.length} appointment{dayAppointments.length === 1 ? "" : "s"}
          </Badge>
        </div>
        {dayAppointments.length === 0 ? (
          <div className="text-center text-slate-400 py-16">No appointments on this day.</div>
        ) : (
          <div className="space-y-3" data-testid="calendar-day-list">
            {dayAppointments.map((a) => (
              <div key={a.id} data-testid="calendar-appt-item" className="flex items-center gap-4 border border-slate-200 rounded-xl p-4 hover:bg-slate-50">
                <div className="flex flex-col items-center justify-center w-16 shrink-0">
                  <Clock className="h-4 w-4 text-teal-600 mb-1" />
                  <span className="font-mono text-sm font-semibold text-slate-800">
                    {new Date(a.appointment_date).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-slate-900">
                    {a.patient_name} <span className="text-slate-400 text-sm">• {a.patient_age} yrs</span>
                  </div>
                  <div className="text-sm text-slate-500">{a.doctor_name} • {a.disease_name || "—"}</div>
                </div>
                <Badge variant="outline" className={`capitalize ${STATUS[a.status] || ""}`}>{a.status}</Badge>
                <Button size="icon" variant="ghost" onClick={() => onViewReceipt(a)} title="View receipt">
                  <Eye className="h-4 w-4" />
                </Button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
